import React, { useState, useEffect } from "react";
import { Button, Upload, Alert, Tabs, Select, Input } from "antd";
import { UploadOutlined, FileExcelOutlined, DatabaseOutlined } from "@ant-design/icons";
import { getAllConnection } from "../../../service/db.service";
import { NAVY } from "../gateway.constants";

const { TextArea } = Input;
const { Option } = Select;

function SourcePanel({
  sourceType, setSourceType,
  uploadedFile, setUploadedFile,
  dbName, setDbName,
  sql, setSql,
  onNext, onBack,
}) {
  const [connections, setConnections] = useState([]);

  useEffect(() => {
    getAllConnection().then((r) => setConnections(r.data || []));
  }, []);

  const canProceed = sourceType === "DB_QUERY" ? (dbName && sql.trim()) : !!uploadedFile;

  return (
    <div>
      <Tabs
        activeKey={sourceType}
        onChange={setSourceType}
        items={[
          {
            key: "CSV_UPLOAD",
            label: <span><FileExcelOutlined /> Upload CSV / Excel</span>,
            children: (
              <div style={{ marginTop: 12 }}>
                <Upload
                  accept=".csv,.xlsx,.xls" maxCount={1}
                  beforeUpload={(f) => { setUploadedFile(f); return false; }}
                  onRemove={() => setUploadedFile(null)}
                  fileList={uploadedFile ? [{ uid: "1", name: uploadedFile.name, status: "done" }] : []}
                >
                  <Button icon={<UploadOutlined />}>Select file (.csv / .xlsx)</Button>
                </Upload>
                {uploadedFile && (
                  <Alert type="success" showIcon style={{ marginTop: 12 }}
                    message={`${uploadedFile.name} ready — columns detected on Next`} />
                )}
              </div>
            ),
          },
          {
            key: "DB_QUERY",
            label: <span><DatabaseOutlined /> Database Query</span>,
            children: (
              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
                <Select
                  showSearch placeholder="Select database"
                  style={{ width: "100%" }}
                  value={dbName || undefined} onChange={setDbName}
                >
                  {connections.map((c) => (
                    <Option key={c.displayName} value={c.displayName}>{c.displayName}</Option>
                  ))}
                </Select>
                <TextArea
                  rows={5} value={sql}
                  onChange={(e) => setSql(e.target.value)}
                  style={{ fontFamily: "monospace", fontSize: 12 }}
                  placeholder={"SELECT portfolio_code, trade_date, isin, quantity, price\nFROM trades\nWHERE trade_date = CURRENT_DATE"}
                />
              </div>
            ),
          },
        ]}
      />
      <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <Button onClick={onBack}>Back</Button>
        <Button type="primary" disabled={!canProceed}
          style={{ background: NAVY, borderColor: NAVY }} onClick={onNext}>
          Detect columns →
        </Button>
      </div>
    </div>
  );
}

export default SourcePanel;
